import script from "./CheckoutV2.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutV2.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/checkouts/v2/checkout_v2.css?vue&type=style&index=0&id=615fe079&scoped=true&lang=css&external"
import "@/assets/css/checkouts/v2/checkout_v2_mobile.css?vue&type=style&index=1&id=615fe079&scoped=true&lang=css&external"
import "./CheckoutV2.vue?vue&type=style&index=2&id=615fe079&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-615fe079"]])

export default __exports__